import { useJss } from '../../../layout/jss'

export default () => {
  const useStyles = useJss({
    printButton: {
      color: 'transparent',
    },
    button: {
      padding: '12px !important',
      borderRadius: '50% !important',
      color: '#760074',
      '&:hover': {
        color: '#209BCD',
      },
    },
  })
  const classes = useStyles()
  return classes
}
